'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertySeatedProductOwned = undefined;

var _createProperty = require('ui-addon-upgrades/_core/common/data/upgradeData/transformers/createProperty');

var _getSeatedProductOwned = require('ui-addon-upgrades/_core/common/eligibility/getSeatedProductOwned');

var PROPERTY_KEY = 'seatedProductOwned';

// If the sales product is owned, we just return the merchandise id of the upgrade product
// If they own a higher tiered product, we return the merchandise id of the higher tiered product they own.
var getPropertySeatedProductOwned = exports.getPropertySeatedProductOwned = function getPropertySeatedProductOwned() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      upgradeProduct = _ref.upgradeProduct,
      product = _ref.product;

  return (0, _getSeatedProductOwned.getSeatedProductOwned)({
    upgradeProduct: upgradeProduct,
    product: product
  }).then(function (seatedProductOwned) {
    return (0, _createProperty.createProperty)(PROPERTY_KEY, seatedProductOwned);
  }).catch(function () {
    return (0, _createProperty.createProperty)(PROPERTY_KEY, null);
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/transformers/getPropertySeatedProductOwned.js
// module id = 476
// module chunks = 3 4 5